import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "./ParticlesAuth";
import "./Login.css";
//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
// actions
import { loginUser, resetLoginFlag } from "../../slices/thunks";
import logoLight from "../../assets/images/logo-farme.png";
import { createSelector } from "reselect";

//import images
const Login = (props) => {
  const dispatch = useDispatch();
  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Login.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));
  // Inside your component
  const { user, error, loading, errorMsg } = useSelector(loginpageData);
  const [userLogin, setUserLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: userLogin.email || "",
      password: userLogin.password  || "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Por favor ingrese su usuario"),
      password: Yup.string().required("Por favor ingrese su contraseña"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 5000);
    }
  }, [dispatch, errorMsg]);

  document.title = "Login | Farme";

  // Formatear mensaje de error para mostrar
  const getErrorMessage = () => {
    if (!error) return null;
    
    // Si el error es un string, mostrarlo directamente
    if (typeof error === 'string') {
      return error;
    }
    
    // Si el error es un objeto con mensaje, mostrar el mensaje
    if (error && error.message) {
      return error.message;
    }
    
    // Si no podemos determinar el mensaje, mostrar un mensaje genérico
    return "Error al iniciar sesión. Por favor, inténtalo de nuevo.";
  };

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row className="mt-4 justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4 shadow-lg border-0">
                  <CardBody className="p-4">
                    <div className="text-center mt-2 mb-4">
                      <Link to="/" className="d-inline-block auth-logo">
                        <img src={logoLight} alt="" height="50" />
                      </Link>
                    </div>
                    {error && (
                      <Alert color="danger" className="d-flex align-items-center">
                        <i className="ri-error-warning-line me-2"></i>
                        <div>{getErrorMessage()}</div>
                      </Alert>
                    )}
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                      >
                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label">
                            Usuario
                          </Label>
                          <div className="form-icon-wrapper">
                            <span className="form-icon-left">
                              <i className="ri-user-line"></i>
                            </span>
                            <Input
                              name="email"
                              type="text"
                              className="form-control ps-5"
                              placeholder="Ingresar Usuario"
                              autoComplete="username"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                validation.errors.email
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.email &&
                            validation.errors.email ? (
                              <FormFeedback type="invalid">
                                {validation.errors.email}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">
                              ¿Olvidó la contraseña?
                            </Link>
                          </div>
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Contraseña
                          </Label>
                          <div className="form-icon-wrapper">
                            <span className="form-icon-left">
                              <i className="ri-lock-line"></i>
                            </span>
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control ps-5 pe-5"
                              placeholder="Ingresar Contraseña"
                              autoComplete="current-password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted px-3"
                              type="button"
                              id="password-addon"
                              onClick={() => setPasswordShow(!passwordShow)}
                              title="Mostrar/ocultar contraseña"
                              style={{ zIndex: 10 }}
                            >
                              {passwordShow ? (
                                <i className="ri-eye-off-line align-middle"></i>
                              ) : (
                                <i className="ri-eye-line align-middle"></i>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="form-check mb-3">
                          <Input
                            type="checkbox"
                            id="remember-me"
                            className="form-check-input"
                          />
                          <Label className="form-check-label" for="remember-me">
                            Recordarme
                          </Label>
                        </div>

                        <div className="mt-4">
                          <Button
                            color="primary"
                            disabled={loading || !(validation.isValid && validation.dirty)}
                            className="btn btn-primary w-100"
                            type="submit"
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm" className="me-2">
                                  Loading...
                                </Spinner>
                                Iniciando sesión...
                              </>
                            ) : (
                              "Ingresar"
                            )}
                          </Button>
                          {!(validation.isValid && validation.dirty) && !loading && (
                            <div className="text-muted text-center mt-2 fs-12">
                              Por favor, complete todos los campos para continuar
                            </div>
                          )}
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
